<template>
  <div class="chat-single">
    <ChatMessages
      v-model="newMessage"
      :details="currentChatDetails"
      :messages="getReversedMessages"
      :locked="isChannelLocked"
      :processing="isSending"
      :show-more="messages.length >= 20 && messages.length < totalMessages"
      @load="loadMoreMessages"
      @upload="showFileUploadDialog"
      @submit="submitMessage"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import ChatMessages from '@/components/Chat/ChatMessages.vue';

export default {
  components: {
    ChatMessages,
  },

  props: {
    channelId: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      newMessage: '',
    };
  },

  computed: {
    ...mapState('chat', [
      'messages',
      'totalMessages',
      'isChannelLocked',
      'isSending',
    ]),
    ...mapGetters('chat', [
      'getSingleChatDetails',
      'getReversedMessages',
    ]),

    currentChatDetails() {
      return this.getSingleChatDetails(this.channelId);
    },
  },

  channels: {
    ChatChannel: {
      received(data) {
        this.addNewMessage(data.message);

        this.$cable.perform({
          channel: 'ChatChannel',
          action: 'update_last_seen',
          chat_id: this.channelId,
        });
      },
    },
  },

  mounted() {
    this.setActiveChannel(this.channelId);

    this.fetchMessages(this.channelId)
      .then(() => {
        this.clearUnreadMessages(this.channelId);

        this.$cable.subscribe({
          channel: 'ChatChannel',
          chat_id: this.channelId,
        });
      });
  },

  destroyed() {
    this.unsubscribe();
    this.setActiveChannel(null);
  },

  methods: {
    ...mapActions('dialog', [
      'showDialog',
    ]),
    ...mapActions('chat', [
      'fetchMessages',
      'fetchMoreMessages',
      'createMessage',
      'addNewMessage',
      'clearUnreadMessages',
      'setActiveChannel',
      'sortChatChannelsByNewestMessage',
    ]),

    submitMessage() {
      const formData = new FormData();
      formData.append('text', this.newMessage);
      this.createMessage({ id: this.channelId, formData })
        .then(() => {
          this.newMessage = '';
          this.sortChatChannelsByNewestMessage(this.channelId);
        });
    },

    showFileUploadDialog() {
      this.showDialog({
        header: 'Dodawanie pliku',
        text: 'Wybierz plik i wyślij jako wiadomość.',
        component: 'ChatFileUpload',
        props: {
          id: this.channelId,
        },
      });
    },

    loadMoreMessages() {
      this.fetchMoreMessages(this.channelId);
    },

    unsubscribe() {
      this.$cable.unsubscribe('ChatChannel');
    },
  },
};
</script>
